import { SET_TAG_LIST, FETCH_ALL } from './types.js'

export default {
  /**
   * Fetch all enteries from tag table
   */
  async [FETCH_ALL] ({ commit }) {
    try {
      const response = await this._vm.$network_utils.getTags()
      commit(SET_TAG_LIST, response)
    } catch (e) {
      console.error(e)
    }
  }
}
